import memoize from "lodash.memoize";

import { typesFor } from "./types";

const createActionsFor = domain => {
  const types = typesFor(domain);

  const changePage = page => ({
    type: types.CHANGE_PAGE,
    payload: page,
    meta: { domain }
  });

  const changeDisplaying = display => ({
    type: types.CHANGE_DISPLAYING,
    payload: display,
    meta: { domain }
  });

  const setTotalRows = totalRows => ({
    type: types.SET_TOTAL_ROWS,
    payload: totalRows,
    meta: { domain }
  });

  const setStartPage = startPage => ({
    type: types.SET_START_PAGE,
    payload: startPage,
    meta: { domain }
  });

  const setEndPage = endPage => ({
    type: types.SET_END_PAGE,
    payload: endPage,
    meta: { domain }
  });

  const hasNextPage = hasNext => ({
    type: types.HAS_NEXT_PAGE,
    payload: hasNext,
    meta: { domain }
  });

  const hasPrevPage = hasPrev => ({
    type: types.HAS_PREV_PAGE,
    payload: hasPrev,
    meta: { domain }
  });

  const goNextPage = () => ({
    type: types.GO_NEXT_PAGE,
    meta: { domain }
  });

  const goPrevPage = () => ({
    type: types.GO_PREV_PAGE,
    meta: { domain }
  });

  const goFirstPage = () => ({
    type: types.GO_FIRST_PAGE,
    meta: { domain }
  });

  const goLastPage = () => ({
    type: types.GO_LAST_PAGE,
    meta: { domain }
  });

  const resetPage = () => ({
    type: types.RESET_PAGE,
    meta: { domain }
  });

  return {
    changePage,
    changeDisplaying,
    setTotalRows,
    setStartPage,
    setEndPage,
    hasNextPage,
    hasPrevPage,
    goNextPage,
    goPrevPage,
    goFirstPage,
    goLastPage,
    resetPage
  };
};

export const actionsFor = memoize(createActionsFor);
